import { useCallback } from 'react';
import { useStore } from '../../store/store';
import { leftShownStatus, useOverlay } from '../../contexts/OverlayContext';
import { scrollToItem } from '../Middle/InfinitePage';

// Quitter le formulaire : le document reprend la place du formulaire, et le
// scroll revient sur la box qu'on était en train de remplir — sans ça on
// retombe en haut du document, loin de la variable qu'on venait de saisir.
// Partagé par le rail (onglet Formulaire cliqué une seconde fois vers un autre
// onglet) et le bouton « Retour au document » de la navbar.
export const useExitFormView = () => {
  const { updateLeftShownStatus } = useOverlay();
  const boxes = useStore(({ boxes }) => boxes);
  const boxVariableSelectedId = useStore(({ boxVariableSelectedId }) => boxVariableSelectedId);
  const handleUnSelectBox = useStore(({ handleUnSelectBox }) => handleUnSelectBox);

  return useCallback((status = leftShownStatus.SUMMARY) => {
    const selectedBox = boxes.find(({ id }) => id === boxVariableSelectedId);
    handleUnSelectBox();
    // Une box réservée au formulaire n'est nulle part dans le document : il n'y
    // a pas d'endroit où la montrer.
    if (selectedBox && !selectedBox.onlyForm) {
      scrollToItem(selectedBox);
    }
    updateLeftShownStatus(status);
  }, [boxes, boxVariableSelectedId, handleUnSelectBox, updateLeftShownStatus]);
};
